import { render, staticRenderFns } from "./AdsSetting.vue?vue&type=template&id=33317b1c&scoped=true&"
import script from "./AdsSetting.vue?vue&type=script&lang=js&"
export * from "./AdsSetting.vue?vue&type=script&lang=js&"
import style0 from "./AdsSetting.vue?vue&type=style&index=0&id=33317b1c&scoped=true&lang=css&"
import style1 from "./AdsSetting.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33317b1c",
  null
  
)

export default component.exports